import { User } from 'types/embedded/user';

export const DEFAULT_USER: User = {
  '@id': '',
  id: '',
  email: '',
  roles: [],
  reddyNumber: 1,
  firstName: '',
  lastName: '',
  isLoaded: false,
  permissions: {},
  userOperationAccess: [],
  providerAccounts: [],
  merchantAccesses: [],
  roleEntities: [],
  corporateEmail: null,
  createdAt: '',
  updatedAt: '',
  alerts: [],
  lang: '/admin/languages/ru',
  rolesValues: [],
};
